const holidays = [
  "05/29/23",
  "07/04/23",
  "09/04/23",
  "11/23/23",
  "12/25/23",
  "01/01/24",
];
export default holidays;
